import { ExternalLink, Calendar } from "lucide-react";

const AGENDA_URL =
  "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0-rn25Dow-PcFCMJZFzlCuwlo4VaEetyTZBEanWpiKesRNnHsKaGOYxDtrYSMY1gEb4H14Fjzy";

export function CalendarioManager() {
  return (
    <div className="space-y-4">
      {/* Header bar */}
      <div className="flex items-center justify-between flex-wrap gap-2">
        <div className="flex items-center gap-2 text-sm text-gray-500 font-primary">
          <Calendar className="w-4 h-4 text-brand-primary shrink-0" />
          Agenda de compromissos — Google Calendar
        </div>
        <a
          href={AGENDA_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-1.5 text-xs font-semibold text-brand-primary hover:underline font-primary"
        >
          Abrir no Google Calendar
          <ExternalLink className="w-3.5 h-3.5" />
        </a>
      </div>

      {/* Embedded calendar */}
      <div
        className="rounded-2xl overflow-hidden border border-gray-100 shadow-sm bg-white"
        style={{ height: "700px" }}
      >
        <iframe
          src={AGENDA_URL}
          width="100%"
          height="100%"
          frameBorder="0"
          scrolling="yes"
          title="Agenda Google Calendar"
        />
      </div>
    </div>
  );
}
